import { camelToKebabCase, useMantineTheme } from '@mantine/core';

import backgroundVideo from '#core/assets/video/background.mp4?url';

import classes from './AppRoot.module.css';

export function AppRoot({ children }: React.PropsWithChildren) {
  const theme = useMantineTheme();

  return (
    <div className={classes.appRoot}>
      <style>{`:root { ${getThemeVariables(theme.other)
        .map(([key, value]) => `${key}: ${value};`)
        .join('\n')} }`}</style>

      <div className={classes.backdrop}>
        <video autoPlay className={classes.backgroundVideo} loop muted playsInline>
          <source src={backgroundVideo} type="video/mp4" />
        </video>
      </div>

      {children}
    </div>
  );
}

function getThemeVariables(obj: Record<string, unknown>, prefix = '--theme'): [string, string | number][] {
  return Object.entries(obj).flatMap(([key, value]) => {
    const kebabKey = camelToKebabCase(key);
    const variableName = `${prefix}-${kebabKey}`;

    if (Array.isArray(value)) {
      return getThemeVariables(Object.fromEntries(value.map((v, i) => [i + 1, v])), variableName);
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
      return getThemeVariables(value as Record<string, unknown>, variableName);
    }

    return [[variableName, value]] as [string, string | number][];
  });
}
